module.exports = __webpack_public_path__ + "img/lxy.9a92a4e0.jpg";